import { datalabHttp } from '@dbl/services/common';
import { useRequest } from 'ahooks';
import { ParmptData } from './interface';
// 此文件作为后续重构gpt会话server文件
export interface IQueryConfig<N = number> {
	// 失败重试次数
	retryCount: N;
	// 节流时长
	debounceWait: N;
	// 小于300ms,不展示loading效果
	loadingDelay: N;
	// 默认初始化执行
	manual: boolean;
	// 轮询页面消失请求挂起
	pollingWhenHidden: boolean;
	// 轮询请求失败次数
	pollingErrorRetryCount: N;
}
export type RequrstBack<T = any> = Promise<{
	//数据列表,可自定义类型传入
	data: T;
	code: number;
	msg: string;
	req: { [key in string]: unknown };
}>;

export type IState = {
	// 游戏code
	gameCode: string;
	// 全部会话返回列表
	messages: Array<string>;
	// 本次会话是否结束
	isCompleted: boolean;
	// 需要上传给后端的用户对话信息
	requestMessages: Array<string>;
	// 循环请求的次数, 最多5次
	loopRequestCount: number;
	//暂定
	results?: [];
	[key: string]: unknown;
};
export const queryInitStatClientConfig: IQueryConfig = {
	retryCount: 3,
	debounceWait: 300,
	loadingDelay: 300,
	manual: false,
	pollingWhenHidden: false,
	pollingErrorRetryCount: 3
};

// prompt推荐
export const useNextAskPromptExample = <T extends unknown>(params?: T) => {
	const fetch = (mutateParams: any) =>
		datalabHttp({
			url: '/api/v1/alg/chatbi/next_ask',
			method: 'post',
			data: mutateParams
		}) as RequrstBack<ParmptData>;
	const data = useRequest(fetch, {
		...queryInitStatClientConfig,
		cacheKey: 'next_ask',
		loadingDelay: 300,
		// debounceWait: 800,
		manual: true,
		retryCount: 0
	});
	return {
		...data
	};
};
